/* eslint-disable no-console */
/* eslint-disable complexity */
import React, { ReactNode } from "react";
import ImService from "@/server/ImService";
import { message } from "antd";
import Prompt from "@/baseComponents/ModalComponent/prompt";
import {
  emptySessionMessage,
  SessionSettingService,
  removeChatSession
} from "@/server/im/SessionService";
import { ClickParam } from "antd/lib/menu";
import {
  Employee,
  Session,
  MessageStatus,
  ChatMessage,
  EmployeeAttribute,
  SessionType,
  SessionTopOrderStatusMapBody
} from "@/types/chat";
import { employeeToUid, getLastMessageDesc, isShowAlias } from "@/utils/chat/message";
import trim from "lodash/trim";
import IconFont from "@/components/icon";
import { mattchEmoji } from "@/components/chat/message/Input/Emoji";
import { convertStringToEmoji } from "@/components/chat/utils/ddemoji";
import { isChatPage, stringEncode } from "@/utils/chat/index";
import moment from "moment";
import { isAINoticeChildSession, isAINoticeSession } from "@/utils/chat/session";
import { analysisLog } from "@/utils/logAnalytics";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import i18n from "@/i18n";
import { FocusSDK, getWebEnvObj } from "@/utils";
import { ICustomAppData } from "@/types/chat/State";
import bus from "@/utils/bus";

const netServer = NetworkCheck.getInstance({
  url: getNetCheckUrl(),
  checkType: UseCheckType.API
});


// 设置置顶会话排序状态
export async function handleTopSessionSort({
  sessionId,
  sortedSessionList
}: {
  sessionId: string;
  sortedSessionList: Session[];
}): Promise<boolean> {  
      const length = sortedSessionList.length;    
      const setSessionStatusList = sortedSessionList.map((e, index) => {
      return {
        sessionId: e.sessionId,
				sessionType: e.sessionType,
				sessionMap: {
					topOrder: length - index
				} 
      }
    }) 
    const status: SessionTopOrderStatusMapBody = {
      setSessionStatusList
    }
    const result = await SessionSettingService.setSessionTopOrder.call(
      ImService.getInstance(),
      sessionId,
      status
    );
    // if (result) {
    //   message.success("排序成功");
    // } else {
    //   message.error("排序失败");
    // }
    return result;
}


export function useHandleContextMenuClick({
  sessionId,
  selectedSessionId,
  t,
  clearSessionMessage,
  history,
  msg,
  session,
  force = 1
}: {
  sessionId: string;
  selectedSessionId: string;
  t: any;
  clearSessionMessage: Function;
  history: any;
  msg: ChatMessage;
  session: any;
  force?: 0 | 1;
}) {  
  const removeSession = async () => {
    const result = await removeChatSession(sessionId, force);
    if (result) {
      message.success(t("success"));
      if (sessionId === selectedSessionId) {
        console.log("getAllSessionList===removeSession", sessionId);
       // 以下代码会导致移除会话后闪烁，先注释掉 【待优化】【京me是切换成上一个会话】       
        history.push("/messages");

      }
    } else {
      message.error(t("failed"));
    }
  };

  const emptyMessage = () => {
    const okAction = async () => {
      const result = await emptySessionMessage(sessionId);
      if (result) {
        message.success(t("success"));
        // 清空消息
        // if (sessionId === selectedSessionId) {
        //     await clearSessionMessage({ sessionId });
        // }
        // TODO cxz
        // if (msg) {
        //     const imService = ImService.getInstance();
        //     await imService.deleteMessage(msg as any);
        // }
        // TODO wzp
        if (sessionId) {
          await clearSessionMessage({ sessionId });
        }
      } else {
        message.error(t("failed"));
      }
    };

    Prompt({
      title: t("session.menus.empty_prompt_title"),
      content: t("session.menus.empty_prompt"),
      okText: t("determine"),
      cancelText: t("cancelText"),
      onOk: okAction
    });
  };

  const setSessionTop = async (top: boolean) => {
    const result = await SessionSettingService.setSessionTop.call(
      ImService.getInstance(),
      sessionId,
      top // true
    );
    if (result) {
      const tip = top ? "top_success_tip" : "untop_success_tip";
      message.success(t(`session.menus.${tip}`));
    } else {
      message.error(t("failed"));
    }
  };

  const setSessionShield = async (shield: boolean) => {
    const result = await SessionSettingService.setSessionShield.call(
      ImService.getInstance(),
      sessionId,
      shield
    );
    if (result) {
      const tip = shield ? "unshield_success_tip" : "shield_success_tip";
      message.success(t(`session.menus.${tip}`));
    } else {
      message.error(t("failed"));
    }
  };

  const setSessionAttention = async (attention: { pin: string; app: string; teamId: string }[]) => {
    const result = await SessionSettingService.setSessionAttention.call(
      ImService.getInstance(),
      sessionId,
      attention
    );
    if (result) {
      // const tip = shield ? "unshield_success_tip" : "shield_success_tip";
      // message.success(t(`session.menus.${tip}`));
    } else {
      message.error(t("failed"));
    }
  };

  const openNewWindow = async () => {
    const { isSingle, sessionId, isSecret } = session;
    const onLine = await netServer.checkNet();
    if (!onLine) {
      message.error(i18n.t("Network Error"));
      return;
    }
    console.log("getAllSessionList===openNewWindow", session);
    
    // 修改FocusSDK中计算窗口数量的逻辑，如果sessionId在已打开的窗口中有，就不+1===xly
    if (FocusSDK.chatWindowNumber(session.info.id) === 3) {
      message.error(t("session.menus.new_window_support"));
      return;
    }
    ImService.getInstance()?.setCurrentSession(sessionId);
    if (isSingle) {
      FocusSDK.launchSingleSession({ ...session?.uid, isSecret: isSecret ? true : false }, () => {
        console.log("单聊");
      });
    } else {
      FocusSDK.launchGroupSession(sessionId, () => {
        console.log("群聊" + sessionId);
      });
    }
    if (sessionId === selectedSessionId) {
      bus.emit("session:openNewWindow", sessionId);
    }
  };

  // 兼容传入 ClickParam 或 直接传入字符串 key
  const extractKey = (params: any): string | undefined => {
    if (!params) return undefined;
    if (typeof params === "string") return params;
    if (typeof params === "object" && (params as any).key) return (params as any).key as string;
    return undefined;
  };

  return async (params?: ClickParam | string) => {
    console.log("参数===", params);
    
    const key = extractKey(params);
    if (!key) return;
    switch (key) {
      case "remove":
        await removeSession();
        break;
      case "empty":
        await emptyMessage();
        break;
      case "top":
        await setSessionTop(true);
        break;
      case "untop":
        await setSessionTop(false);
        break;
      case "shield":
        await setSessionShield(true);
        break;
      case "unshield":
        await setSessionShield(false);
        break;
      case "new":
        await openNewWindow();
        break;
      default:
        break;
    }
  };
}

export function useGetMessageDesc({
  sessionStatusMap,
  currentEmployee,
  selectedSession,
  session,
  allSessionList,
  customAppList
}: {
  sessionStatusMap: any;
  currentEmployee: Employee;
  selectedSession: Session;
  session: Session | null;
  allSessionList: Session[];
  customAppList: Session[];
}) {
  return (): ReactNode => {
    if (!session) {
      return null;
    }
    let _session = session;
    if (isAINoticeSession(session)) {
      const noticeSessionList = allSessionList.filter(
        (item) => item.isNotice && isAINoticeChildSession(item, customAppList) && item.lastMsg
      );
      let targetSession: any = noticeSessionList[0];
      if (targetSession) {
        noticeSessionList.forEach((item) => {
          if (item.lastMsg && (item.lastMsg as any).content) {
            if (
              moment(targetSession.lastMsg?.datetime).unix() < moment(item.lastMsg?.datetime).unix()
            ) {
              targetSession = item;
            }
          }
        });
        _session = {
          ...targetSession,
          lastMsg: {
            ...(targetSession.lastMsg || {}),
            pin: (_session.info as Employee).userId
          }
        };
      }
    }
    const sessionStatusInfo = sessionStatusMap[_session.sessionId] || {};
    if (selectedSession.sessionId === _session.sessionId) {
      if (!_session.lastMsg) {
        return null;
      }
      const _html = getLastMessageDesc(
        _session?.lastMsg || null,
        _session.sessionType,
        currentEmployee,
        false,
        _session
      );
      if (!_html) {
        return null;
      }
      return (
        <p
          className="dangerous-inner-html"
          dangerouslySetInnerHTML={{
            __html: _html
          }}
        />
      );
    } else if (
      sessionStatusInfo &&
      sessionStatusInfo.status === MessageStatus.EDITING &&
      trim(sessionStatusInfo.info.content)
    ) {
      const content =
        isShowAlias(session) && sessionStatusInfo.info.atContent
          ? `${sessionStatusInfo.info.atContent}`
          : `${sessionStatusInfo.info.content}`;
      return (
        <div className="edit-icon">
          <IconFont type="iconapp_ic_draft" />
          <p
            className="edit-content"
            dangerouslySetInnerHTML={{
              __html: mattchEmoji(convertStringToEmoji(stringEncode(content)))
            }}
          />
        </div>
      );
    } else {
      if (!_session.lastMsg) {
        return null;
      }
      const lastMsg = _session?.lastMsg as ChatMessage;
      const _html = getLastMessageDesc(
        lastMsg || null,
        session.sessionType,
        currentEmployee,
        false,
        _session
      );
      if (!_html) {
        return null;
      }
      return (
        <p
          className="dangerous-inner-html"
          dangerouslySetInnerHTML={{
            __html: _html
          }}
        />
      );
    }
  };
}

export function useHandleSessionClick({
  selectedSession,
  session,
  launchSingleSession,
  initSelectedSession,
  launchGroupSession,
  launchNoticeSession,
  launchOrgNoticeSession,
  setCallBack,
  changeSelectMore,
  updateMessages,
  history,
  closeSetting,
  basename,
  readMsgCustom,
  shouldCreate
}: {
  selectedSession: Session;
  session: Session | null;
  launchSingleSession: Function;
  initSelectedSession: Function;
  launchGroupSession: Function;
  launchNoticeSession: Function;
  launchOrgNoticeSession: Function;
  setCallBack?: Function;
  changeSelectMore: Function;
  updateMessages: Function;
  history: any;
  closeSetting?: () => void;
  basename: string;
  readMsgCustom: string;
  shouldCreate?: boolean;
}) {

  return async () => {
    if (!session) {
      return null;
    }
    if (isAINoticeSession(session)) {
      analysisLog("Xtbg_Msg_AI", "Home");
    }

    if (selectedSession.sessionId !== session.sessionId) {
      changeSelectMore({ selectMore: false });
      updateMessages({ messages: [] });
      const { isSingle, info, sessionId, id, isNotice, isSecret } = session;
      const { REACT_APP_BUILD_ELECTRON } = process.env;
      const { REACT_APP_ROUTE_BASE } = getWebEnvObj();
      let currentBasename = "";
      if (REACT_APP_BUILD_ELECTRON === "true") {
        currentBasename = basename;
      } else {
        currentBasename = REACT_APP_ROUTE_BASE || basename || "";
      }
      if (isSingle && !isNotice) {
        const { app, teamId, userId } = info as EmployeeAttribute;
        if (!userId || !app || !teamId) {
          return;
        }
        const prevInfo = selectedSession.info as EmployeeAttribute;
        // if (
        //     prevInfo &&
        //     prevInfo.app === app &&
        //     prevInfo.teamId === teamId &&
        //     prevInfo.userId === userId &&
        //     selectedSession.isSecret !== isSecret
        // ) {
        //     await initSelectedSession({ selectedSession: {} });
        // }
        if (
          userId.startsWith("sub_") ||
          [SessionType.ORG_NORMAL, SessionType.ORG_BROADCAST].includes(session?.sessionType)
        ) {
          const orgType = session?.sessionType === SessionType.ORG_NORMAL ? "1" : "0";
          launchOrgNoticeSession({ sid: sessionId, type: orgType, top: shouldCreate });
          history.push(`/messages/s/${userId}?app=${app}&tid=${teamId}&type=${orgType}&top=${shouldCreate}`);
          closeSetting?.();
          return;
        }
        const type = isSecret ? SessionType.SECRET_SINGLE : SessionType.SINGLE;
        // window.history.pushState(
        //     {},
        //     '',
        //     `${currentBasename}/messages/s/${userId}${
        //         isSecret ? ':secret' : ''
        //     }?app=${app}&tid=${teamId}&secret=${isSecret}`
        // );
        const sMid =
          session?.unreadCount === 0 || readMsgCustom === "last"
            ? ""
            : session?.lastReadMid || session?.lastMid || "";
        // FocusSDK.printLog("lyj---进入单聊会话", readMsgCustom, sMid);
        launchSingleSession({ user: employeeToUid(info as EmployeeAttribute), type, sMid, top: shouldCreate });
        history.push(
          `/messages/s/${userId}${
            isSecret ? ":secret" : ""
          }?app=${app}&tid=${teamId}&secret=${isSecret}&top=${shouldCreate}`
        );
        closeSetting?.();
      } else if (session.isGroup) {
        if (!sessionId) {
          return;
        }
        const sMid =
          session?.unreadCount === 0 || readMsgCustom === "last"
            ? ""
            : session?.lastReadMid || session?.lastMid || "";
        // FocusSDK.printLog("lyj---进入组聊会话", readMsgCustom, sMid);
        launchGroupSession({ sid: sessionId || id, sMid, top: shouldCreate });
        // window.history.pushState(
        //     {},
        //     '',
        //     `${currentBasename}/messages/g/${sessionId || id}`
        // );
        history.push(`/messages/g/${sessionId || id}?top=${shouldCreate}`);
        closeSetting?.();
      } else if (isNotice) {
        launchNoticeSession({ sid: sessionId || id, top: shouldCreate });
        // window.history.pushState(
        //     {},
        //     '',
        //     `${currentBasename}/messages/n/${sessionId || id}`
        // );
        history.push(`/messages/n/${sessionId || id}?top=${shouldCreate}`);
        closeSetting?.();
      }
    }
    if (setCallBack) {
      setCallBack(session);
    }
  };
}

export function useHandleAITabClick({
  selectedAITab,
  session,
  launchAINoticeTabSession,
  setCallBack,
  // changeSelectMore,
  // updateMessages,
  // history,
  closeSetting
}: {
  selectedAITab: Session & { pin: string };
  session: (Session & { pin: string }) | null;
  launchAINoticeTabSession: Function;
  setCallBack?: Function;
  // changeSelectMore: Function;
  // updateMessages: Function;
  // history: any;
  closeSetting?: () => void;
}) {
  return () => {
    if (!session) {
      return null;
    }
    if (selectedAITab.pin !== session.pin) {
      const { sessionId, id, pin } = session;
      // changeSelectMore({ selectMore: false });
      // updateMessages({ messages: [] });
      launchAINoticeTabSession({ pin, sessionId });
      // window.history.pushState({}, '', `/messages/n/${sessionId || id}`);
      // history.push(`/messages/n/${sessionId || id}`);
      closeSetting?.();
    }
    if (setCallBack) {
      setCallBack(session);
    }
  };
}

// 创建密聊 以及密聊和普通聊天切换
export function useHandleSessionTypeClick({
  selectedSession,
  launchSingleSession,
  initSelectedSession,
  closeConfirmModal,
  updateMessages,
  changeSelectMore,
  history
}: {
  selectedSession: Session;
  launchSingleSession: Function;
  initSelectedSession: Function;
  closeConfirmModal?: () => void;
  changeSelectMore: Function;
  updateMessages: (data: { messages: ChatMessage[] }) => void;
  history: any;
}) {
  return async () => {
    const onLine = await netServer.checkNet();
    if (!onLine) {
      message.error(i18n.t("Network Error"));
    }
    if (!selectedSession) {
      return null;
    }
    const info = selectedSession.info as EmployeeAttribute;
    const { app, teamId, userId } = info;
    if (!userId || !app || !teamId) {
      return;
    }
    const type = selectedSession.isSecret ? SessionType.SINGLE : SessionType.SECRET_SINGLE;
    // await initSelectedSession({ selectedSession: {} });
    // if (isChatPage()) {
    //   let url = location.href.replace(new RegExp(`secret=${selectedSession.isSecret}`, "g"), `secret=${!selectedSession.isSecret}`);
    //   window.history.pushState({}, "", url);
    // }
    history.push(
      `/messages/s/${userId}${
        !selectedSession.isSecret ? ":secret" : ""
      }?app=${app}&tid=${teamId}&secret=${!selectedSession.isSecret}&top=${selectedSession.del === 1}`
    );
    await launchSingleSession({
      user: employeeToUid(info),
      type: type,
      top: selectedSession.del === 1
    });
    changeSelectMore({ selectMore: false });
    updateMessages({ messages: [] });
    closeConfirmModal?.();
  };
}

// const removeSession = async () => {
//     const instance = ImService.getInstance();
//     const result = await instance.removeSession(sessionProps.sessionId);
//     if (result) {
//         message.success(t('success'));
//         if (sessionProps.sessionId === selectedSession.sessionId) {
//             window.history.pushState({}, '', `/messages`);
//         }
//     } else {
//         message.error(t('failed'));
//     }
// };
//
// const emptyMessage = () => {
//     const okAction = async () => {
//         const result = ImService.getInstance().emptySession(sessionProps.sessionId);
//         if (result) {
//             message.success(t('success'));
//             // 清空消息
//             if (sessionProps.sessionId === selectedSession.sessionId) {
//                 await clearSessionMessage({ sessionId: sessionProps.sessionId });
//             }
//         } else {
//             message.error(t('failed'));
//         }
//     };
//
//     Prompt({
//         title: t('session.menus.empty_prompt_title'),
//         content: t('session.menus.empty_prompt'),
//         okText: t('determine'),
//         cancelText: t('cancelText'),
//         onOk: okAction,
//     });
// };
//
// const setSessionTop = async (top: boolean) => {
//     const result = await SessionSettingService.setSessionTop.call(
//         ImService.getInstance(),
//         sessionProps.sessionId,
//         top // true
//     );
//     if (result) {
//         const tip = top ? 'top_success_tip' : 'untop_success_tip';
//         message.success(t(`session.menus.${tip}`));
//     } else {
//         message.error(t('failed'));
//     }
// };
//
// const setSessionShield = async (shield: boolean) => {
//     const result = await SessionSettingService.setSessionShield.call(
//         ImService.getInstance(),
//         sessionProps.sessionId,
//         true
//     );
//     if (result) {
//         const tip = shield ? 'unshield_success_tip' : 'shield_success_tip';
//         message.success(t(`session.menus.${tip}`));
//     } else {
//         message.error(t('failed'));
//     }
// };
//
// const handleContextMenuClick = async (params: ClickParam) => {
//     switch (params.key) {
//         case 'remove':
//             await removeSession();
//             break;
//         case 'empty':
//             emptyMessage();
//             break;
//         case 'top':
//             await setSessionTop(true);
//             break;
//         case 'untop':
//             await setSessionTop(false);
//             break;
//         case 'shield':
//             await setSessionShield(true);
//             break;
//         case 'unshield':
//             await setSessionShield(false);
//             break;
//         default:
//             break;
//     }
// };
// const getMessageDesc = (): ReactNode => {
//     const sessionStatusInfo = sessionStatusMap[sessionProps.sessionId] || {};
//     if (selectedSession.sessionId === sessionProps.sessionId) {
//         return (
//             <p
//                 className="dangerous-inner-html"
//                 dangerouslySetInnerHTML={{
//                     __html: getLastMessageDesc(
//                         session?.lastMsg || null,
//                         sessionProps.sessionType,
//                         currentEmployee,
//                         false
//                     ),
//                 }}
//             />
//         );
//     } else if (
//         sessionStatusInfo &&
//         sessionStatusInfo.status === MessageStatus.EDITING &&
//         trim(sessionStatusInfo.info.content)
//     ) {
//         return (
//             <div className="edit-icon">
//                 <IconFont type="iconapp_ic_draft" />
//                 <span className="edit-content">{sessionStatusInfo.info.content}</span>
//             </div>
//         );
//     } else {
//         const lastMsg = session?.lastMsg as ChatMessage;
//         return (
//             <p
//                 className="dangerous-inner-html"
//                 dangerouslySetInnerHTML={{
//                     __html: getLastMessageDesc(
//                         lastMsg || null,
//                         sessionProps.sessionType,
//                         currentEmployee,
//                         false
//                     ),
//                 }}
//             />
//         );
//     }
// };

// const handleClick = () => {
//     if (!session) {
//         return null;
//     }
//     if (selectedSession.sessionId !== session.sessionId) {
//         const { isSingle, info, sessionId, id, isNotice } = session;
//         if (isSingle && !isNotice) {
//             const { app, teamId, userId } = info as EmployeeAttribute;
//             if (!userId || !app || !teamId) {
//                 return;
//             }
//             launchSingleSession({ user: employeeToUid(info as EmployeeAttribute) });
//             window.history.pushState({}, '', `/messages/s/${userId}?app=${app}&tid=${teamId}`);
//         } else if (session.isGroup) {
//             if (!sessionId) {
//                 return;
//             }
//             launchGroupSession({ sid: sessionId || id });
//             window.history.pushState({}, '', `/messages/g/${sessionId || id}`);
//         } else if (isNotice) {
//             launchNoticeSession({ sid: sessionId || id });
//             window.history.pushState({}, '', `/messages/n/${sessionId || id}`);
//         }
//     }
//     if (setCallBack) {
//         setCallBack();
//     }
// };
